import { useState } from 'react';
import { acceptanceType } from '../../hooks/useAcceptance';
import { useAcceptanceData } from '../../hooks/useAcceptanceData';
import { useFullScreenModal } from '../../hooks/useFullScreenModal';

const links = [
  {
    type: acceptanceType.user_agreement,
    title: 'Пользовательское соглашение',
  },
  {
    type: acceptanceType.personal_data_processing_policy,
    title: 'Политика обработки персональных данных',
  },
  {
    type: acceptanceType.offer_for_the_provision_of_paid_services,
    title: 'Оферта об оказании платных услуг',
  },
];

export function ProfileAcceptanceLinks() {
  const [activeType, setActiveType] = useState(null);
  const { acceptance, isLoading } = useAcceptanceData(activeType);
  const { Modal, setOpen } = useFullScreenModal();

  const handleClick = (type) => {
    setActiveType(type);
    setOpen(true);
  };

  return (
    <>
      {links.map((i) => (
        <button
          key={i.type}
          onClick={() => handleClick(i.type)}
          className="text-xs font-medium text-[#FFFFFF] opacity-70 text-start"
        >
          {i.title}
        </button>
      ))}

      {acceptance && (
        <Modal title={acceptance.title}>
          <div className="whitespace-pre-line">{acceptance.content}</div>
        </Modal>
      )}
    </>
  );
}
